/**
 * 欄位顯示設定：固定 localStorage key + 內部 schemaVersion。
 * 之後改預設欄位只需 bump schemaVersion，不必改 key 名稱。
 */

/**
 * @param {object} options
 * @param {string} options.storageKey 固定 key（不含 v1/v2 後綴）
 * @param {number} options.schemaVersion 預設欄位變更時遞增
 * @param {string[]} options.allColumnKeys 目前所有合法欄位 key
 * @param {string[]} options.defaultVisible 新使用者／版本升級後的預設可見欄位
 * @param {string[]} [options.legacyKeys] 舊版 key，讀取後會遷移到新格式
 * @returns {string[]}
 */
export function loadVisibleColumns({
    storageKey,
    schemaVersion,
    allColumnKeys,
    defaultVisible,
    legacyKeys = []
}) {
    const validKeys = new Set(allColumnKeys);
    const filterValid = (keys) =>
        keys.filter((key) => validKeys.has(key));

    let raw = localStorage.getItem(storageKey);

    if (!raw) {
        for (const legacyKey of legacyKeys) {
            const legacy = localStorage.getItem(legacyKey);
            if (legacy) {
                raw = legacy;
                break;
            }
        }
    }

    if (!raw) {
        return [...defaultVisible];
    }

    try {
        const parsed = JSON.parse(raw);

        if (
            parsed &&
            typeof parsed === 'object' &&
            !Array.isArray(parsed) &&
            Array.isArray(parsed.columns)
        ) {
            if (parsed.version !== schemaVersion) {
                return [...defaultVisible];
            }
            const columns = filterValid(parsed.columns);
            return columns.length > 0 ? columns : [...defaultVisible];
        }

        if (Array.isArray(parsed) && parsed.length > 0) {
            const columns = filterValid(parsed);
            if (columns.length > 0) {
                saveVisibleColumns(storageKey, schemaVersion, columns);
                return columns;
            }
        }
    } catch {
        // fall through
    }

    return [...defaultVisible];
}

/**
 * @param {string} storageKey
 * @param {number} schemaVersion
 * @param {string[]} columns
 */
export function saveVisibleColumns(storageKey, schemaVersion, columns) {
    localStorage.setItem(
        storageKey,
        JSON.stringify({
            version: schemaVersion,
            columns
        })
    );
}
